export function getRootFromFieldExpression(fieldExpression: string): string {
  return fieldExpression.includes(".") ? fieldExpression.split(".")[0] : fieldExpression;
}

